<template>
  <div>
    <Header :title="title" :showBack="true"></Header>
    <ul class="m-1.5 text-left text-[.385rem]">
      <li v-if="analysisTicketAboutRight">
        <div class="mb-1">检票相关：</div>
        <div class="stats_panel">
          <p>
            当前：<b>{{ nowStr }}</b>
          </p>
          <ul class="flex text-center pt-1 w-full">
            <li class="flex-1">
              <p class="stats_item_title">班次数</p>
              <p class="stats_item_value">{{ checkStats.TotalClassCount }}班</p>
            </li>
            <li class="flex-1">
              <p class="stats_item_title">总检票数</p>
              <p class="stats_item_value">{{ checkStats.TotalCheckCount }}班</p>
            </li>
          </ul>
          <div
            class="detail_btn"
            @click="gotoDetail('/AnalysisStats/CheckStats')"
          >
            <b>查看更多详情</b>
          </div>
        </div>
      </li>
      <li class="mt-1.5">
        <div class="mb-1">更多查询：</div>
        <div class="stats_panel">
          <ul class="flex text-center">
            <li
              class="w25"
              v-for="(item, index) in analysisMoreQuerylist"
              :key="index"
              @click="gotoDetail(item.path)"
              v-show="item.isDisplay"
            >
              <p :class="['iconfont', item.icon]"></p>
              <p class="stats_item_name">{{ item.label }}</p>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import "@/views/AnalysisStats/style.less";
import Header from "@/components/Header/Header.vue";

// 获取本地权限
const getLocalRight = (rightCode) => {
  let value = false;
  if (Array.isArray(JSON.parse(window.localStorage.getItem("adminRights")))) {
    let rightsArray = JSON.parse(window.localStorage.getItem("adminRights"));
    rightsArray.forEach(function(v) {
      v.Rights.forEach(function(z) {
        if (z.RightCode == rightCode) {
          value = z.IsRight;
          return;
        }
      });
    });
  } else {
    //兼容更新后未重新获取权限的情况
    value = true;
  }
  return value;
};

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "统计分析",
      operObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员对象
      checkStats: {
        TotalClassCount: 0,
        TotalCheckCount: 0,
      },

      analysisTicketAboutRight: false, // 检票相关权限
      // 更多查询
      analysisMoreQuerylist: [
        {
          label: "检票查询",
          RightCode: "IsAllowCheckDataQuery",
          path: "/AnalysisStats/CheckQuery",
          icon: "icondingdanjihe",
          isDisplay: false,
        },
        {
          label: "订单查询",
          RightCode: "IsAllowQueryOrderQuery",
          path: "/AnalysisStats/OrderQuery",
          icon: "icondingdanjihe",
          isDisplay: false,
        },
        {
          label: "班次客座率",
          RightCode: "IsAllowQueryAttendanceRatio",
          path: "/AnalysisStats/AttendanceRatio",
          icon: "iconshichangbishuai",
          isDisplay: false,
        },
      ],
    };
  },
  computed: {
    nowStr() {
      return this.$moment(new Date()).format("YYYY-MM-DD");
    },
  },
  methods: {
    // 获取权限
    getStatisticAnalysisRight() {
      // 更多查询权限
      this.analysisMoreQuerylist.forEach((item) => {
        item.isDisplay = getLocalRight(item.RightCode);
      });
      // 检票相关
      this.analysisTicketAboutRight = getLocalRight("IsAllowQueryCheckQuery");
    },
    gotoDetail(path) {
      this.$router.push({ path });
    },
    doQuery() {
      this.checkQuery();
    },
    checkQuery() {
      let now = new Date();
      this.$http
        .post(this.$api.DriverTicketCheckDataQuery, {
          DriverGID: this.operObj.GID,
          BeginDate: this.$moment(now).format("YYYY-MM-DD 00:00:00"),
          // BeginDate: this.$moment(now).subtract(1, 'year').format('YYYY-MM-DD 00:00:00'),
          EndDate: this.$moment(now).format("YYYY-MM-DD 23:59:59"),
          // 都设置成0会查询所有
          start: 0,
          limit: 1,
        })
        .then((res) => {
          this.checkStats = res.totalData[0];
        });
    },
  },
  created() {
    this.doQuery();
    this.getStatisticAnalysisRight();
  },
};
</script>

<style lang="less" scoped>
.iconfont {
  color: #ea986c;
  font-size: 0.533rem;
}
</style>
